import { Flex } from "@similarweb/ui-components/foundations";

import type { TrafficSignalEventDto } from "app/pages/sales-intelligence/modules/company-analysis/types/signals";
import CountryService from "app/services/CountryService";

import StyledSignalCountryTag from "../SignalCountryTag/StyledSignalCountryTag";

type TrafficSignalEventInfoProps = {
    signal: TrafficSignalEventDto;
};

const TrafficSignalEventInfo = ({ signal }: TrafficSignalEventInfoProps) => {
    const { countries } = signal;

    if (typeof countries !== "undefined") {
        return (
            <Flex
                flexWrap="wrap"
                gap="8px"
                margin="0 0 16px 0"
            >
                {countries.map((countryId) => {
                    const { text } = CountryService.getCountryById(countryId);

                    return (
                        <StyledSignalCountryTag
                            key={countryId}
                            countryCode={countryId}
                            text={text}
                        />
                    );
                })}
            </Flex>
        );
    }

    return null;
};

export default TrafficSignalEventInfo;
